/* PillContainer alignment */
/** ******************* */
// Later on start and end will be added as well
const EGDSPillContainerAlignmentMap = [['center', 'uitk-pill-container-align-center']];
const EGDSPillContainerAlignments = new Map(EGDSPillContainerAlignmentMap);
export { EGDSPillContainerAlignments };